<div class="card panel-default">
    <div class="card-body" *ngIf="currentLayer">
        <!-- Sublayers-->
        <div [hidden]="!currentLayer.sublayers" class="form-group">
            <div *ngFor="let subLayer of getSubLayers()">
                <hs-layer-editor-sub-layer-checkbox [subLayer]="subLayer">
                </hs-layer-editor-sub-layer-checkbox>
            </div>
        </div>
        <div *ngIf="currentLayer.settings">
            <form>
                <hs-panel-container [service]="hsWidgetContainerService" (init)="createWidgets()">
                </hs-panel-container>
            </form>
            <div class="btn-group m-auto d-flex w-75" *ngIf="currentLayer.visible && getBase(currentLayer.layer)">
                <button class="btn btn-sm btn-outline-primary  w-50"
                    (click)="HsLayerManagerService.setGreyscale(currentLayer)"
                    [ngClass]="{'active' : !getGreyscale(currentLayer.layer)}" data-toggle="tooltip"
                    [title]="'LAYERMANAGER.layerEditor.zoomToLayer' | translateHs  ">{{'COMMON.color' |
                    translateHs }}</button>
                <button class="btn btn-sm btn-outline-primary  w-50"
                    (click)="HsLayerManagerService.setGreyscale(currentLayer)"
                    [ngClass]="{'active' : getGreyscale(currentLayer.layer)}" data-toggle="tooltip"
                    [title]="'LAYERMANAGER.layerEditor.styleLayer' | translateHs  ">{{'LAYERMANAGER.baseMapGallery.greyscale'
                    | translateHs }}</button>
            </div>
        </div>
    </div>
    <div class="card-footer" *ngIf="currentLayer?.settings">
        <div class="form-group" [hidden]="!layer_renamer_visible">
            <label>{{'COMMON.title' | translateHs }}</label>
            <div class="input-group">
                <input type="text" class="form-control" [(ngModel)]="title" name="title">
                <button [hidden]="!titleUnsaved()" (click)="saveTitle()" class="btn btn-outline-secondary"
                    type="button"><i class="icon-save-floppy"></i></button>
                <!-- TODO: Remove function call from template -->
            </div>
        </div>
        <div class="btn-group" role="group" [attr.aria-label]="'LAYERMANAGER.editorButtons' | translateHs  ">
            <button class="btn btn-primary" (click)="zoomToLayer()" [disabled]="!layerIsZoomable()"
                data-toggle="tooltip" [title]="'LAYERMANAGER.layerEditor.zoomToLayer' | translateHs  ">
                <!-- TODO: Remove function call from template --><i class="icon-search"></i>
            </button>
            <button class="btn btn-primary" (click)="styleLayer()" [disabled]="!layerIsStyleable()"
                data-toggle="tooltip" [title]="'LAYERMANAGER.layerEditor.styleLayer' | translateHs  "><i
                    class="icon-brush"></i></button><!-- TODO: Remove function call from template -->
            <button class="btn btn-primary" (click)="toggleLayerRename()" data-toggle="tooltip"
                [title]="'COMMON.renameLayer' | translateHs  "><i class="icon-textfield"></i></button>
            <button class="btn btn-primary" (click)="createSaveDialog()" data-toggle="tooltip"
                *ngIf="HsLayerEditorService.isLayerVectorLayer(currentLayer.layer)"
                [title]="'LAYERMANAGER.layerEditor.savegeojson' | translateHs  ">
                <!-- TODO: Remove function call from template --><i class="icon-save-floppy"></i>
            </button>
            <button class="btn btn-primary" (click)="copyLayer()" data-toggle="tooltip"
                [title]="'COMMON.copyLayer' | translateHs  "><i class="icon-copy"></i></button>
            <button class="btn btn-danger" (click)="removeLayer()" *ngIf="isLayerRemovable()" data-toggle="tooltip"
                [title]="'COMMON.removeLayer' | translateHs  "><i class="icon-trash"></i></button>
            <!-- TODO: Remove function call from template -->
        </div>
    </div>

</div>